// extracted by mini-css-extract-plugin
export var closeButton = "_p9-2";
export var closeButtonIcon = "_p9-3";
export var lightboxContent = "_p9-1";
export var lightboxOverlay = "_p9-0";